import React from 'react';
import { Container, TextField } from '@material-ui/core';
import Card from 'src/views/register/Card';

import { collection, query } from 'firebase/firestore';
import { useFirestoreCollectionData, useFirestore } from 'reactfire';
export const TELEGRAM_BOT = process.env.REACT_APP_BOTNAME;

const RegisterView = ({ name, setName }) => {
  const migrationsCollection = collection(useFirestore(), 'migrations');
  const migrationsQuery = query(migrationsCollection);
  const { data, error } = useFirestoreCollectionData(migrationsQuery, {
    idField: 'id',
  });
  const migrationLists = data?.map((x) => x.id);

  return (
    <Container>
      <Card
        title="Step1: Invitation code"
        description={<>Enter your invitation code below to continue</>}
      >
        {/* cf2c1988-a67d-4972-ac1e-02157c9754de */}
        <TextField
          label="Share Link"
          variant="outlined"
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth
        />
      </Card>
    </Container>
  );
};

export default RegisterView;
